var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAscActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05473 0.202045L0.129939 3.25183C0.0897199 3.29393 0.0580085 3.34095 0.0348051 3.3929C0.0116017 3.44468 0 3.50025 0 3.55961C0 3.67818 0.0384403 3.78126 0.115321 3.86885C0.192201 3.95628 0.293523 4 0.419285 4H6.58071C6.70648 4 6.8078 3.9558 6.88468 3.8674C6.96156 3.77916 7 3.67616 7 3.55841C7 3.52889 6.95661 3.42669 6.86983 3.25183L3.94527 0.202045C3.87814 0.131874 3.80868 0.0806565 3.73691 0.048394C3.66513 0.0161314 3.58616 0 3.5 0C3.41384 0 3.33487 0.0161314 3.26309 0.048394C3.19132 0.0806565 3.12186 0.131874 3.05473 0.202045Z",
    fill: "#595D72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscActive);
export default __webpack_public_path__ + "static/media/asc_active.27ed0508b008a1e34b10d65a90d83a58.svg";
export { ForwardRef as ReactComponent };